module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }